// import HomeView from '@/App.vue'
import GoodsView from "@/view/GoodsView.vue";
import HomeView from "@/view/IndexView.vue";

export const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        // meta: { title: '首页' }
    },
    {
        path: '/goods',
        name: 'goods',
        component: GoodsView,
        // meta: { title: '详情' }
    },

]

